module.exports = __webpack_public_path__ + "img/excel.a534f487.svg";